import React from 'react';
import { SignInButton, useAuth } from '@clerk/react';
import { LockIcon } from './Icons';
import { T } from '../designTokens';

// ---------------------------------------------------------------------------
// Auth helpers
// ---------------------------------------------------------------------------

export function AuthState({ signedIn, signedOut, loading }: { signedIn: React.ReactNode; signedOut: React.ReactNode; loading?: React.ReactNode }) {
  const { isLoaded, isSignedIn } = useAuth();
  if (!isLoaded) return <>{loading || null}</>;
  return isSignedIn ? <>{signedIn}</> : <>{signedOut}</>;
}

export function AuthWall({ title, message }: { title: string; message: string }) {
  // Light ground, cobalt CTA (DESIGN.md "Brand accent", #1934): the old
  // indigo-to-purple gradient on a dark card predated the design system.
  return (
    <div
      style={{
        backgroundColor: T.white,
        borderRadius: '16px',
        padding: '64px 40px',
        textAlign: 'center',
        border: `1px solid ${T.gray200}`,
        maxWidth: '540px',
        margin: '40px auto',
      }}
    >
      <div style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '56px',
        height: '56px',
        borderRadius: '50%',
        backgroundColor: T.cobalt50,
        border: `1px solid ${T.cobalt200}`,
        marginBottom: '24px',
      }}>
        <LockIcon size={26} color={T.cobalt600} />
      </div>
      <h2 style={{ margin: '0 0 12px', color: T.gray900, fontSize: '22px', fontWeight: 700 }}>
        {title}
      </h2>
      <p style={{ margin: '0 0 28px', color: T.gray600, fontSize: '15px', lineHeight: '1.6' }}>
        {message}
      </p>
      <SignInButton mode="modal">
        <button
          style={{
            padding: '12px 32px',
            fontSize: '15px',
            fontWeight: 700,
            color: T.white,
            backgroundColor: T.cobalt600,
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            transition: 'background-color 0.15s',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = T.cobalt700; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = T.cobalt600; }}
        >
          Sign In
        </button>
      </SignInButton>
    </div>
  );
}
